import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function BarChart({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 14.611C15 14.825 14.825 15 14.611 15H12.938C12.725 15 12.55 14.825 12.55 14.611V1.388C12.55 1.174 12.725 1 12.938 1H14.611C14.825 1 15 1.174 15 1.388V14.611ZM14.611 0H12.938C12.173 0 11.55 0.623 11.55 1.388V14.611C11.55 15.377 12.173 16 12.938 16H14.611C15.377 16 16 15.377 16 14.611V1.388C16 0.623 15.377 0 14.611 0ZM9.22564 14.611C9.22564 14.825 9.05064 15 8.83564 15H7.16364C6.94964 15 6.77464 14.825 6.77464 14.611V6.348C6.77464 6.133 6.94964 5.959 7.16364 5.959H8.83564C9.05064 5.959 9.22564 6.133 9.22564 6.348V14.611ZM8.83564 4.959H7.16364C6.39764 4.959 5.77464 5.582 5.77464 6.348V14.611C5.77464 15.377 6.39764 16 7.16364 16H8.83564C9.60264 16 10.2256 15.377 10.2256 14.611V6.348C10.2256 5.582 9.60264 4.959 8.83564 4.959ZM3.06124 15C3.27524 15 3.45024 14.825 3.45024 14.611V11.307C3.45024 11.093 3.27524 10.919 3.06124 10.919H1.38824C1.17524 10.919 1.00024 11.093 1.00024 11.307V14.611C1.00024 14.825 1.17524 15 1.38824 15H3.06124ZM1.38824 9.919H3.06124C3.82724 9.919 4.45024 10.542 4.45024 11.307V14.611C4.45024 15.377 3.82724 16 3.06124 16H1.38824C0.623244 16 0.000244141 15.377 0.000244141 14.611V11.307C0.000244141 10.542 0.623244 9.919 1.38824 9.919Z'
      />
    </svg>
  );
}
